import React from 'react';

const DeleteProject = ({
  modalInfo,
  handleCloseModal,
  handleDeleteProject
}) => {
  return (
    <div className="delete-modal-content">
      <p>Delete Launchplan: {modalInfo.brand_name}</p>
      <div className="delete-modal-buttons">
        <button
          className="btn btn--secondary-outline delete-modal-button"
          onClick={() => handleDeleteProject(modalInfo.ID)}
        >
          Delete
        </button>
        <button
          className="btn btn--primary-outline delete-modal-button"
          onClick={handleCloseModal}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeleteProject;
